module.exports = __webpack_public_path__ + "img/EASY_OF_OPERATION.4b8253f3.jpg";